import React from 'react';
import PropTypes from "prop-types";
import Slide from "@mui/material/Slide";
import { TransitionGroup } from "react-transition-group";
import ActionButton from "../Buttons/ActionButton";
import Tooltip from "@mui/material/Tooltip";

const OptionalFormSection = (props) => {
    const containerRef = React.useRef(null);

    const [ expanded, setExpanded ] = React.useState(props.isExpanded || !props.isCollapsible);

    const toggleExpanded = () => {
        props.onExpanded(!expanded);
        setExpanded(!expanded);
    }

    return (
        <section
            className={`section form-container full optional-form-section ${props.className}`}
        >
            <div
                className={`grid-x optional-form-header ${expanded ? 'open' : 'closed'}`}
            >
                <div className="cell small-8">
                    {props.title}
                    {(props.tooltip) && (
                        <Tooltip title={props.tooltip}>
                            <a className="form-row-tooltip">
                                &nbsp;<i className="fa fa-info-circle"/>
                            </a>
                        </Tooltip>
                    )}
                </div>
                <div className="cell small-4">
                    <div className="button-group medium margin-0 align-right">
                        {(props.isCollapsible) && (
                            <ActionButton
                                icon={(expanded) ? 'fa-minus' : 'fa-plus'}
                                onClick={e => toggleExpanded()}
                            />
                        )}
                    </div>
                </div>
            </div>

            <div
                className={`optional-form-body ${expanded ? 'open' : 'closed'}`}
                ref={containerRef}
                style={{overflowY: 'clip'}}
            >
                <TransitionGroup>
                    {(expanded) && (
                        <Slide timeout={500} container={containerRef.current}>
                            <div>
                                { props.children }
                            </div>
                        </Slide>
                    )}
                </TransitionGroup>
            </div>
        </section>
    )
}

OptionalFormSection.propTypes = {
    onExpanded: PropTypes.func,
    isExpanded: PropTypes.bool,
    isCollapsible: PropTypes.bool,
    className: PropTypes.string,
}

OptionalFormSection.defaultProps = {
    isCollapsible: true,
    className: '',
}

export default OptionalFormSection;
